import React, { useEffect } from 'react';
import { AppProvider } from './context/AppContext';
import Router from './Router';
import './styles/globals.css';

function App() {
  useEffect(() => {
    // Apply dark theme by default
    document.documentElement.classList.add('dark');
  }, []);

  return (
    <AppProvider>
      <Router />
    </AppProvider>
  );
}

export default App;